import {charcoal} from '../sass/base/_exports.sass';

export const RotationIcon = ({color = charcoal, className = '', ratio = 1, onClick}) => {
  // default dimensions
  const width = 41;
  const height = 40;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    // biome-ignore lint/a11y/useKeyWithClickEvents: existing functionality
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <rect x={1} y={0.5} width={39} height={39} rx={7.5} fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 13.875C15.3452 13.875 15.625 14.1548 15.625 14.5V15.978C15.7767 15.839 15.9426 15.6955 16.1221 15.552C17.1429 14.7353 18.6529 13.875 20.5 13.875C22.1245 13.875 23.6824 14.5203 24.831 15.669C25.9797 16.8176 26.625 18.3755 26.625 20C26.625 21.6245 25.9797 23.1824 24.831 24.331C23.6824 25.4797 22.1245 26.125 20.5 26.125C18.7982 26.125 17.2754 25.3868 16.1829 24.3605C15.1007 23.3438 14.375 21.9794 14.375 20.66C14.375 20.3148 14.6548 20.035 15 20.035C15.3452 20.035 15.625 20.3148 15.625 20.66C15.625 21.5406 16.1304 22.5962 17.0388 23.4495C17.9368 24.2932 19.164 24.875 20.5 24.875C21.7929 24.875 23.0329 24.3614 23.9471 23.4471C24.8614 22.5329 25.375 21.2929 25.375 20C25.375 18.7071 24.8614 17.4671 23.9471 16.5529C23.0329 15.6386 21.7929 15.125 20.5 15.125C19.0471 15.125 17.8071 15.8047 16.9029 16.528C16.7227 16.6722 16.5579 16.8165 16.4096 16.955H17.64C17.9852 16.955 18.265 17.2348 18.265 17.58C18.265 17.9252 17.9852 18.205 17.64 18.205H15.0073C14.9855 18.2053 14.9636 18.2044 14.9417 18.2023C14.7793 18.1873 14.6348 18.1101 14.5324 17.9947C14.4345 17.8844 14.375 17.7391 14.375 17.58V14.5C14.375 14.1548 14.6548 13.875 15 13.875Z"
        fill={color}
      />
      <rect x={1} y={0.5} width={39} height={39} rx={7.5} stroke="#E1E3E6" />
    </svg>
  );
};
